import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { Check, X } from 'lucide-react';
export function ForWhomSection() {
  return <section className="bg-parchment py-20 px-6 md:px-8" data-id="element-52">
      <div className="max-w-3xl mx-auto" data-id="element-53">
        <AnimatedSection data-id="element-54">
          <h2 className="text-3xl md:text-4xl font-serif text-bark mb-12 text-center" data-id="element-55">
            Para quién es (y para quién no)
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-56">
            {/* For You */}
            <div className="bg-linen p-8 rounded-sm shadow-sm border-t-4 border-gold" data-id="element-57">
              <h3 className="font-serif font-bold text-xl text-bark mb-6 flex items-center gap-2" data-id="element-58">
                <span className="text-gold" data-id="element-59">✓</span> Esto es para vos si:
              </h3>
              <ul className="space-y-4" data-id="element-60">
                <li className="flex items-start gap-3" data-id="element-61">
                  <Check size={18} className="text-gold mt-1 flex-shrink-0" data-id="element-62" />
                  <span className="text-bark/90" data-id="element-63">
                    querés rezar pero la vida no te da margen
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-64">
                  <Check size={18} className="text-gold mt-1 flex-shrink-0" data-id="element-65" />
                  <span className="text-bark/90" data-id="element-66">
                    te pesa la culpa de “estar fría” o “haber aflojado”
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-67">
                  <Check size={18} className="text-gold mt-1 flex-shrink-0" data-id="element-68" />
                  <span className="text-bark/90" data-id="element-69">
                    te cuesta sostener hábitos
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-70">
                  <Check size={18} className="text-gold mt-1 flex-shrink-0" data-id="element-71" />
                  <span className="text-bark/90" data-id="element-72">
                    necesitás algo concreto y breve, sin tecnicismos
                  </span>
                </li>
              </ul>
            </div>

            {/* Not For You */}
            <div className="bg-linen/50 p-8 rounded-sm border-t-4 border-bark/20" data-id="element-73">
              <h3 className="font-serif font-bold text-xl text-bark/70 mb-6 flex items-center gap-2" data-id="element-74">
                <span className="text-bark/40" data-id="element-75">✕</span> No es para vos si:
              </h3>
              <ul className="space-y-4" data-id="element-76">
                <li className="flex items-start gap-3" data-id="element-77">
                  <X size={18} className="text-bark/40 mt-1 flex-shrink-0" data-id="element-78" />
                  <span className="text-bark/70" data-id="element-79">
                    buscás un curso teológico profundo
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-80">
                  <X size={18} className="text-bark/40 mt-1 flex-shrink-0" data-id="element-81" />
                  <span className="text-bark/70" data-id="element-82">
                    querés una devoción larga y estricta desde el día 1
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-83">
                  <X size={18} className="text-bark/40 mt-1 flex-shrink-0" data-id="element-84" />
                  <span className="text-bark/70" data-id="element-85">
                    solo te sirve si “sentís algo” al rezar
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}